import cx from 'classnames';

import Text from 'shared_components/Text';

import collections from 'assets/units/collections.png';
import market from 'assets/units/market.png';
import leaderboards from 'assets/units/leaderboards.png';

import styles from '../../styles.module.scss';

const Features = (props: React.HTMLProps<HTMLDivElement>) => (
  <div {...props} className={cx(styles.features, props.className)}>
    <Text
      as="h3"
      size="3xl"
      weight="medium"
      uppercase
      className={styles.gradientText}
    >
      The <strong>features</strong>
    </Text>
    <Text className={styles.paragraph} as="p" size="md">
      A community built to provide the best experience for collectors, with easy
      trades, great looking collections and ZERO gas fees.
    </Text>
    <div className={styles.featureGrid}>
      <div className={styles.feature}>
        <img
          alt="Collections"
          src={collections}
          className={styles.collectionsImage}
        />
        <div>
          <Text
            className={styles.heading}
            as="h5"
            weight="bold"
            type="white"
            size="2xl"
          >
            Collections
          </Text>
          <Text as="p" size="md">
            Easily view your collection and see the cards you still need to find
            to finish the set. Easily sort by rarity, artist, and more.
          </Text>
        </div>
      </div>
      <div className={styles.feature}>
        <img
          alt="Leaderboards"
          src={leaderboards}
          className={styles.leaderboardImage}
        />
        <div>
          <Text
            className={styles.heading}
            as="h5"
            weight="bold"
            type="white"
            size="2xl"
          >
            Leaderboards
          </Text>
          <Text as="p" size="md">
            Every card has a leaderboard score based on its mint number and
            rarity. Complete the set and find the rarest cards to take the top
            spot.
          </Text>
        </div>
      </div>

      <div className={styles.feature}>
        <img alt="Exchange" src={market} className={styles.marketImage} />
        <div>
          <Text
            className={styles.heading}
            as="h5"
            weight="bold"
            type="white"
            size="2xl"
          >
            Kolectiv Exchange
          </Text>
          <Text as="p" size="md">
            Kolectiv provides a community exchange where you can buy, sell and
            trade your cards without gas fees. Connect your metamask wallet to
            easily take custody of your cards and use third party markets like
            Opensea.
          </Text>
        </div>
      </div>
    </div>
  </div>
);

export default Features;
